import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import PrivateRoute from "./PrivateRouter";
import {
  Home,
  Agents,
  Listings,
  Login,
  Signup,
  Forgot,
  Agentt,
  Listing,
  Dashboard,
  UserProfile,
  Messages,
  Password,
  AddLisiting,
  AdminListingList,
  AdminAgentsList,
  AgentListing,
} from "./pages";
import AgentAdding from "./pages/agents-adding";
import Image3D from "./pages/image3DPage";

const App = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/agents" component={Agents} />
        <Route exact path="/listing" component={Listings} />
        <Route exact path="/agent/:id" component={Agentt} />
        <Route exact path="/property/:id" component={Listing} />
        <Route exact path="/image3d/:id" component={Image3D} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/add-agents" component={AgentAdding} />
        <PrivateRoute exact path="/forgot-password" component={Forgot} />
        <PrivateRoute exact path="/dashboard" component={Dashboard} />
        <PrivateRoute exact path="/profile" component={UserProfile} />
        <PrivateRoute exact path="/messages" component={Messages} />
        <PrivateRoute exact path="/change-password" component={Password} />
        <PrivateRoute path="/add-listing/:id?" component={AddLisiting} />
        <PrivateRoute exact path="/all-listing" component={AdminListingList} />
        <PrivateRoute exact path="/all-agents" component={AdminAgentsList} />
        <PrivateRoute exact path="/mylisting" component={AgentListing} />
      </Switch>
    </Router>
  );
};

export default App;
